import { TFunc } from 'types/common';

export class AsyncGuarder<T = void> {
  private _currentPromise: Promise<T> | null = null;

  public run(fn: TFunc<T>): Promise<T> {
    if (this._currentPromise) {
      return this._currentPromise;
    }

    this._currentPromise = new Promise<T>((resolve, reject) => {
      Promise.resolve()
        .then(() => fn())
        .then((result: T) => {
          this._currentPromise = null;
          resolve(result);
        })
        .catch((err) => {
          this._currentPromise = null;
          reject(err);
        });
    });
    return this._currentPromise;
  }
}
